import {
  ActionIcon,
  Box,
  Button,
  Grid,
  Input,
  Select,
  Title,
  Tooltip,
} from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconEdit,
  IconSearch,
  IconSwitch,
  IconZoomReset,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_Row,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { _localization } from "../../../config/location";
import "../../../Styles/tab.component.css";
import { DataPickerView } from "./DataPickerView";
import EditWarrantyRenewal from "./EditWarrantyRenewal";
import { useLocation } from "react-router-dom";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const WarrantyRenewalList = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  const [height, setHeight] = useState(0);
  const [data, setData] = useState<WarrantyRenewalListItem[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const [search, setSearch] = useState<any>({
    status: _searchJson && checkedPinSearch ? _searchJson?.status : "",
  });

  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300
  );

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData: any) => ({ ...prevData, [key]: value }));
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        size: 50,
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        size: 30,
      },
      {
        accessorKey: "serial",
        header: "Mã serial",
        size: 30,
      },

      {
        accessorKey: "itemType",
        header: "Loại hàng",
        size: 30,
      },
      {
        accessorKey: "sell",
        header: "Bán",
        size: 30,
        Cell: ({ cell }) => (
          <div
            style={{
              backgroundColor: cell.getValue() ? "#46C25C" : "#F44336",
              color: "white",
              borderRadius: "10px",
              padding: "5px",
              width: "80px",
              textAlign: "center",
            }}
          >
            {cell.getValue() ? "Bán" : "Không bán"}
          </div>
        ),
      },
      {
        accessorKey: "active",
        header: "Trạng thái",
        size: 30,
        Cell: ({ cell }) => (
          <div
            style={{
              backgroundColor: cell.getValue() ? "#298FE7" : "#F8A793",
              color: "white",
              borderRadius: "10px",
              padding: "5px",
              width: "100px",
              textAlign: "center",
            }}
          >
            {cell.getValue() ? "Mới 100%" : "Đã qua sử dụng"}
          </div>
        ),
      },
      {
        accessorKey: "display",
        header: "Hàng trưng bày",
        size: 30,
        Cell: ({ cell }) => (
          <div
            style={{
              backgroundColor: cell.getValue() ? "#46C25C" : "#F44336",
              color: "white",
              borderRadius: "10px",
              padding: "5px",
              width: "80px",
              textAlign: "center",
            }}
          >
            {cell.getValue() ? "Trưng bày" : "Không trưng bày"}
          </div>
        ),
      },
      {
        accessorKey: "experience",
        header: "Trải Nghiệm",
        size: 30,
      },
      {
        accessorKey: "promotion",
        header: "Khuyến mãi",
        size: 50,
        Cell: ({ cell }) => (
          <div
            style={{
              backgroundColor: cell.getValue() ? "#298FE7" : "#F8A793",
              color: "white",
              borderRadius: "10px",
              padding: "5px",
              width: "50px",
              textAlign: "center",
            }}
          >
            {cell.getValue() ? "Có" : "Không"}
          </div>
        ),
      },
      {
        accessorKey: "warrantyRenew",
        header: "Đổi mới 100%",
        size: 30,
        Cell: ({ cell }) => (
          <div
            style={{
              backgroundColor: cell.getValue() ? "#46C25C" : "#F44336",
              color: "white",
              borderRadius: "10px",
              padding: "5px",
              width: "80px",
              textAlign: "center",
            }}
          >
            {cell.getValue() ? "Áp dụng" : "Không áp dụng"}
          </div>
        ),
      },
      {
        accessorKey: "warrantyRepair",
        header: "Sửa chữa",
        size: 30,
        Cell: ({ cell }) => (
          <div
            style={{
              backgroundColor: cell.getValue() ? "#46C25C" : "#F44336",
              color: "white",
              borderRadius: "10px",
              padding: "5px",
              width: "80px",
              textAlign: "center",
            }}
          >
            {cell.getValue() ? "Áp dụng" : "Không áp dụng"}
          </div>
        ),
      },
      {
        accessorKey: "warrantyExchange",
        header: "Đổi hàng (sử dụng)",
        // width: 250,
        Cell: ({ cell }) => (
          <div
            style={{
              backgroundColor: cell.getValue() ? "#46C25C" : "#F44336",
              color: "white",
              borderRadius: "10px",
              padding: "5px",
              width: "80px",
              textAlign: "center",
            }}
          >
            {cell.getValue() ? "Áp dụng" : "Không áp dụng"}
          </div>
        ),
      },
      {
        accessorKey: "billing",
        header: "Trả tính phí",
        size: 30,
        Cell: ({ cell }) => (
          <div
            style={{
              backgroundColor: cell.getValue() ? "#46C25C" : "#F44336",
              color: "white",
              borderRadius: "10px",
              padding: "5px",
              width: "80px",
              textAlign: "center",
            }}
          >
            {cell.getValue() ? "Áp dụng" : "Không áp dụng"}
          </div>
        ),
      },
      {
        accessorKey: "period",
        header: "Thời hạn ",
        size: 20,
      },
      {
        accessorKey: "endDate",
        header: "Ngày hết hạn",
        size: 30,
      },
      {
        accessorKey: "oldPeriod",
        header: "Thời hạn ( cũ )",
        size: 20,
      },
      {
        accessorKey: "oldEndDate",
        header: "Ngày hết hạn ( cũ )",
        size: 30,
      },
      {
        accessorKey: "employeeName",
        header: "Tên người sửa",
        size: 30,
      },
      {
        accessorKey: "lastUpdateDate",
        header: "Ngày cập nhật",
        size: 30,
      },

      {
        accessorKey: "action",
        header: "Thao tác",
        size: 10,

        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {processTaskActionMenu(row)}
          </Box>
        ),
      },
    ],
    [data]
  );

  function processTaskActionMenu(row: MRT_Row<any>): any {
    return (
      <>
        <Tooltip label="Sửa">
          <ActionIcon variant="light" aria-label="Settings" color="yellow">
            <IconEdit size={20} onClick={() => handleEdit(row?.original.id)} />
          </ActionIcon>
        </Tooltip>
      </>
    );
  }

  const handleEdit = (id: number | string) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa</Title>
        </>
      ),
      size: "auto",
      children: <EditWarrantyRenewal id={id} onClose={setDeleteViewStatus} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleSearch = async () => {
    let termData;
    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (keySearch) {
      url += `&KeySearch=${keySearch.trim()}`;
    }

    if (search.status) {
      url += `&Active=${search.status}`;
    }

    try {
      const response = await repositoryMdm.get(
        `/api/v1/TblSerialStatus/get-list${url}`
      );
      if (response && response.success) {
        termData = response.data;
      }
    } catch (error) {
      console.error(error);
      return;
    }
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chọn thông tin</Title>
        </>
      ),
      size: "xl",
      children: <DataPickerView data={termData} setData={setData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (keySearch) {
      url += `&KeySearch=${keySearch.trim()}`;
    }

    if (search.status) {
      url += `&Active=${search.status}`;
    }

    try {
      const response = await repositoryMdm.get(
        `/api/v1/TblSerialStatus/get-list${url}`
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        })
      );
    }
  };
  useEffect(() => {
    fetchData();
  }, [deleteViewStatus]);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningWarrantyRenewalList"
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-select", "code"],
          right: ["action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage()
  );

  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningWarrantyRenewalList",
      JSON.stringify(columnPinning)
    );
  }, [columnPinning]);

  const table = useMantineReactTable({
    columns,
    data,
    rowCount,
    enableColumnFilters: false,
    enableSorting: false,
    enableColumnActions: true,
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      columnPinning,
      // rowSelection,
    },
    manualFiltering: false,
    manualSorting: false,
    manualPagination: true,
    onPaginationChange: setPagination,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef} style={{ width: "100%" }}>
        <_breadcrumb></_breadcrumb>
        <Grid w={"100%"}>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              size="sm"
              placeholder="Trạng thái"
              searchable
              clearable
              value={search.status || null}
              data={[
                { value: "true", label: "Mới 100%" },
                { value: "false", label: "Đã qua sử dụng" },
              ]}
              leftSection={<IconSwitch color="#15aabf" />}
              onChange={(value) =>
                handleChangeSearchValue(value ?? "", "status")
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Input
              placeholder="Nhập từ khóa tìm kiếm"
              type="text"
              defaultValue={keySearch}
              leftSection={<IconSearch color="#15aabf" />}
              onChange={(e) => {
                setKeySearch(e.target.value ?? "");
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Button
              color="blue"
              variant="outline"
              onClick={() => {
                handleSearch();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => (
      <>
        <Button
          leftSection={<IconZoomReset size={14} />}
          color="violet"
          variant="outline"
          onClick={async () => {
            await fetchData();
          }}
        >
          Load data
        </Button>
      </>
    ),

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontSize: "11.5px",
        padding: "4px 12px",
      },
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["10", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (200 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    fetchData();
  }, [pagination]);
  return (
    <>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default WarrantyRenewalList;

export type WarrantyRenewalListItem = {
  active: boolean;
  billing: boolean;
  createBy: string;
  createDate: Date;
  display: boolean;
  experience: string;
  id: string;
  itemCode: string;
  itemName: string;
  itemType: string;
  lastUpdateBy: string;
  lastUpdateDate: string;
  promotion: boolean;
  sell: boolean;
  serial: string;
  warrantyExchange: boolean;
  warrantyRenew: boolean;
  warrantyRepair: boolean;
};
